(function () {
    'use strict';

    angular
        .module('blocks.filters')
        .filter('utcToLocal', utcToLocal)
        .filter('utcToLocalDate', utcToLocalDate);


    function utcToLocal() {
        return function (input) {
            var local = moment.utc(input).toDate();
            var r = moment(local).format("MM/DD/YYYY hh:mm A");
            if (r === "Invalid date") {
                return "";
            }
            else {
                return r;
            }
        }
    }

    function utcToLocalDate() {
        return function (input) {
            var local = moment.utc(input).toDate();
            return moment(local).format("MM/DD/YYYY");
        }
    }

})();

